export const ANNOUNCEMENTS_ACCESS_CONTROL_SYSTEMS = [
  {
    value: 'brivo',
    label: 'Brivo',
  },
  {
    value: 'smartair',
    label: 'Smartair',
  },
  {
    value: 'comelit',
    label: 'Comelit',
  },
  {
    value: 'two_n',
    label: '2N',
  },
  {
    value: 'Akuvox',
    label: 'akuvox',
  },
  {
    value: 'bmx',
    label: 'BMX',
  },
  {
    value: 'dormakaba',
    label: 'Dormakaba',
  },
  {
    label: 'Lyazon',
    value: 'lyazon',
  },
  {
    value: 'zerv',
    label: 'Zerv',
  },
  {
    value: 'salto',
    label: 'Salto',
  },
  {
    value: 'keyscan',
    label: 'Keyscan',
  },
];

export const ANNOUNCEMENTS_VIDEO_STREAM_SERVICES = [
  {
    value: 'eagle_eye',
    label: 'Eagle Eye',
  },
  {
    value: 'bmx',
    label: 'BMX',
  },
];
